<app-custom-modal>
    <h4 modal-title>
        {{ "overview.instant_payout" | translate }}
    </h4>
    <ng-container modal-body>
        <p>{{ "overview.instant_payout_description" | translate }}</p>

        <br />
        <div class="label-with-sum">
            <p>{{ "overview.instant_payout_label_1" | translate }}</p>
            <p style="font-weight: 600">{{ payoutAmountFormatted() }}</p>
        </div>
        <div class="aw-hr"></div>

        <div class="label-with-sum">
            <p>{{ "overview.instant_payout_label_2" | translate }}</p>
            <p style="font-weight: 600">{{ this.payoutFee }}</p>
        </div>

        <div class="label-with-sum" style="padding-top: 12px">
            <p style="font-weight: 600">{{ "overview.instant_payout_label_3" | translate }}</p>
            <p style="font-weight: 600">{{ this.payoutResult() }}</p>
        </div>
    </ng-container>
    <ng-container modal-footer>
        <app-aw-button [loading]="loading" [disabled]="this.negativePayout()" (clickEmitter)="confirmInstantPayout()" size="large">
            <span button-content>{{ "overview.instant_payout_confirm" | translate }}</span>
        </app-aw-button>
        @if (this.negativePayout()) {
            <p style="padding-top: 5px; font-style: italic; font-size: 0.8rem">{{ "overview.instant_payout_negative" | translate }}</p>
        }
    </ng-container>
</app-custom-modal>
